import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FeedbackReply from './FeedbackReply';
import FeedbackReceipt from './FeedbackReceipt';

class FeedbackDetail extends React.Component {
  render() {
    const {
      feedbacks,
      feedbackMessages,
      onSubmitReply,
      transactionDetail,
      feedbackType,
      feedbackMode,
    } = this.props;

    return (
      <div className="col-md-12 no-padding" id="customer-feedback-detail">
        <FeedbackReply
          feedbacks={feedbacks}
          feedbackMessages={feedbackMessages}
          onSubmit={onSubmitReply}
          feedbackType={feedbackType}
          feedbackMode={feedbackMode}
        />
        <FeedbackReceipt transactionDetail={transactionDetail} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        feedback: state.customers.feedback,
      },
    },
  };
}

FeedbackDetail.propTypes = {
  feedbackMessages: PropTypes.object,
  transactionDetail: PropTypes.object,
  onSubmitReply: PropTypes.func,
  feedbackType: PropTypes.string,
  feedbackMode: PropTypes.string,
};

export default connect(mapStateToProps)(FeedbackDetail);
